import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { AppSettings } from '../app.settings';
import {
  DesignationStateModel,
  DesignationActions,
  Designation
} from '../transaction-store/designation';
import { GaClient } from '../../init';
import { SetCartDesignations } from '../../init/idonatelib';
import { NgForm } from '@angular/forms';

const DEFAULT_DES = { id: null, amount: 0, title: '' };

@Component({
  selector: 'app-multi-designation-modal',
  template: `
    <form #multiDesForm="ngForm" (ngSubmit)="onSubmit(multiDesForm)">
      <div class="modal-header">
        <button
          class="close"
          (click)="dismiss()"
          aria-label="close"
          aria-label="Close modal"
        >
          &times;
        </button>
        <div class="w-100 text-center">
          <h2>Add a gift</h2>
        </div>
      </div>
      <div class="modal-body container">
        <div class="w-100" *ngIf="showRangeValidation">
          <p class="text-danger">
            Amounts must be greater than zero and sum up between
            {{ min | currency: currencyCode:'symbol-narrow' }} and
            {{ max | currency: currencyCode:'symbol-narrow' }}.
          </p>
        </div>
        <div class="w-100" *ngIf="showValidation">
          <p class="text-danger">Please Choose a Designation</p>
        </div>
        <div class="multi-designation-form collapsed-form">
          <div
            class="form-group row align-items-center designation-row"
            *ngFor="let des of currentDesignations.items; let i = index"
            [ngModelGroup]="'fulldes' + i"
          >
            <i
              class="icon-closex primary-color remove-designation"
              aria-label="Remove designation"
              (click)="removeDesignation('current', i)"
            ></i>
            <select-field
              class="col-9"
              label="Designation"
              [items]="designationOptions"
              [showValidation]="showValidation"
              [required]="true"
              [searchable]="true"
              [searchFn]="searchDesignations"
              [name]="'des'"
              [(ngModel)]="des.id"
            >
            </select-field>
            <currency-field
              class="col-3"
              label="Amount"
              [ngModel]="des.amount"
              [showValidation]="showValidation"
              [name]="'amount'"
              (ngModelChange)="onChange($event)"
              [currencyCode]="currencyCode"
              [required]="true"
              [min]="1"
            >
            </currency-field>
          </div>
          <div
            class="form-group row align-items-center designation-row"
            *ngFor="let des of addedDesignations; let i = index"
            [ngModelGroup]="'addeddes' + i"
          >
            <i
              class="icon-closex primary-color remove-designation"
              aria-label="Remove designation"
              (click)="removeDesignation('added', i)"
            ></i>
            <select-field
              class="col-9"
              label="Designation"
              [items]="designationOptions"
              [showValidation]="showValidation"
              (ngModelChange)="onDesignationChange($event)"
              [searchable]="true"
              [searchFn]="searchDesignations"
              [required]="true"
              [name]="'des'"
              [(ngModel)]="des.id"
            >
            </select-field>
            <currency-field
              class="col-3"
              label="Amount"
              [ngModel]="des.amount"
              [showValidation]="showValidation"
              (ngModelChange)="onChange($event)"
              [name]="'amount'"
              [currencyCode]="currencyCode"
              [required]="true"
              [min]="1"
            >
            </currency-field>
          </div>
        </div>
        <designation-more-info
          moreInfoDesignationId="{{ selectedDesignationId }}"
        ></designation-more-info>
      </div>
      <div class="modal-footer">
        <div class="mx-auto">
          <button class="btn btn-primary" type="submit" aria-label="Continue">
            Continue
          </button>
          <span class="separator">or</span>
          <a
            (click)="addDesignation(multiDesForm)"
            aria-label="Add another gift"
            >Add another gift</a
          >
        </div>
      </div>
    </form>
  `
})
export class MultiDesignationModalComponent {
  designationOptions = [];
  minAmount;
  min: number;
  max: number;
  currencyCode = 'USD';
  showValidation = false;
  showRangeValidation = false;
  currentDesignations: DesignationStateModel;
  selectedDesignationId: any = null;
  addedDesignations: Designation[] = [{ ...DEFAULT_DES }];
  @ViewChild('multiDesForm', { static: false }) public thisForm: NgForm;
  @Select() designations$: Observable<DesignationStateModel>;
  constructor(
    public modal: NgbActiveModal,
    private settings: AppSettings,
    private store: Store
  ) {
    this.min = this.settings.getValue('minimumAmount');
    this.max = this.settings.getValue('maximumAmount');
    this.currencyCode = this.settings.getValue('organization').currency_code;
    // server will now pre-filter and pre-sort designations
    this.designationOptions = this.settings
      .getValue('organization')
      .designations.filter(item => item.is_active)
      .map(this.convertToSelect);
    this.designations$.subscribe(
      item => (this.currentDesignations = { ...item, items: [...item.items] })
    );
  }
  convertToSelect(item) {
    return {
      attributes: item.attributes,
      tags: item.tags,
      text: item.title,
      val: item.id
    };
  }
  searchDesignations(search, item) {
    if (!search) {
      return true;
    }
    const searchMatch = new RegExp(search, 'i');

    if (item.text.match(searchMatch)) {
      return true;
    }

    for (const attr of item.attributes) {
      if (attr.searchable) {
        if (attr.value.match(searchMatch) || attr.code.match(searchMatch)) {
          return true;
        }
      }
    }
    if (item.tags && item.tags.match(searchMatch)) {
      return true;
    }
  }
  setDesignations(form) {
    if (form.valid) {
      const designations: Designation[] = [];
      for (const key of Object.keys(form.value)) {
        designations.unshift({
          id: form.value[key].des,
          amount: parseFloat(form.value[key].amount),
          title: this.designationOptions.find(
            item => form.value[key].des === item.val
          ).text
        });
      }
      this.store.dispatch(new DesignationActions.SetDesignations(designations));
      SetCartDesignations(designations);
    }
  }
  addDesignation(form) {
    if (form.valid) {
      this.addedDesignations.push({ ...DEFAULT_DES });
      this.showValidation = false;
      this.showRangeValidation = false;

      GaClient.trackLinkClick('Add Multi-Designation');
    } else {
      this.checkValidation(form);
    }
  }
  onDesignationChange($event) {
    this.checkValidation(this.thisForm);
    this.selectedDesignationId = $event;
  }
  onChange($event) {
    GaClient.trackFieldAction('Multi-Designation Amount', $event);
    this.checkValidation(this.thisForm);
  }
  onSubmit(form) {
    const customValidationResults = this.checkValidation(form);
    if (form.valid && customValidationResults) {
      this.setDesignations(form);
      GaClient.trackButtonClick('Continue from Pop Up');
      this.modal.close();
    }
  }
  dismiss() {
    GaClient.trackIconClick();
    this.modal.dismiss();
  }
  removeDesignation(type, index) {
    if (type === 'current') {
      this.currentDesignations.items = this.currentDesignations.items.filter(
        (item, i) => i !== index
      );
    } else if (type === 'added') {
      this.addedDesignations = this.addedDesignations.filter(
        (item, i) => i !== index
      );
    }
  }
  checkValidation(form) {
    let dTotalDonation = 0;
    this.showRangeValidation = false;
    this.showValidation = false;
    let bValid = true;
    for (const key in form.value) {
      if (!form.value[key].amount) {
        this.showRangeValidation = true;
        bValid = false;
      } else {
        dTotalDonation += form.value[key].amount;
      }
      if (!form.value[key].des) {
        this.showValidation = true;
        bValid = false;
      }
    }
    if (dTotalDonation < this.min || dTotalDonation > this.max) {
      this.showRangeValidation = true;
      bValid = false;
    }
    return bValid;
  }
}
